
import { Component, Input } from '@angular/core';
import { EShoppingCartValidationError, ShoppingCartValidationResultDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { CartValidationResultCartComponent } from './cart/cart-validation-result-cart.component';
import { CartValidationResultCartItemComponent } from './cart-item/cart-validation-result-cart-item.component';


@Component({
    selector: 'app-cart-validation-result',
    imports: [
    CartValidationResultCartComponent,
    CartValidationResultCartItemComponent
],
    templateUrl: './cart-validation-result.component.html',
    styleUrls: ['./cart-validation-result.component.scss']
})
export class CartValidationResultComponent {
  @Input() public cartValidationResult: ShoppingCartValidationResultDto | undefined;
  @Input() public shouldDisplayValidResult?: boolean | undefined;
  @Input() public shouldDisplayCartErrorList?: boolean | undefined;
  @Input() public shouldDisplayCartItemErrorList?: boolean | undefined;

  public eCartValidationError: typeof EShoppingCartValidationError;

  public constructor() {
    this.eCartValidationError = EShoppingCartValidationError;
  }
 }
